module.exports = __webpack_public_path__ + "img/itpro-20230831.012cf42d.jpg";